<template>
  <div class="animated fadeIn employee-worksheet">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header employee-worksheet__header">
          <div class="d-flex at-center justify-content-between main-body-header attendance-header">
            <div class="d-flex at-center title-header attendance-header__title-row">
              <div class="attendance-header__title">
                <h4>Bảng công</h4>
              </div>
              <div class="ml-2 attendance-header__month">
                <el-select
                  class="el-input__filter"
                  v-model="
                    mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id
                  "
                  @change="fn_changeSalaryPeriod"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listSalaryPeriod"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="d-flex justify-content-end w-100 attendance-legend-wrap">
              <div class="d-flex note-circle text-left attendance-legend">
                <div md="2" class="d-flex at-center mr-3 attendance-legend__item">
                  <div class="circle-note full-work attendance-legend__dot"></div>
                  <p class="mb-0">Công đủ</p>
                </div>
                <div md="2" class="d-flex at-center mr-3 attendance-legend__item">
                  <div class="circle-note work-have-problem attendance-legend__dot"></div>
                  <p class="mb-0">Công có vấn đề</p>
                </div>
                <div md="2" class="d-flex at-center mr-3 attendance-legend__item">
                  <div class="circle-note go-to-work-on-holiday attendance-legend__dot"></div>
                  <p class="mb-0">Làm ngày lễ</p>
                </div>
                <div md="2" class="d-flex at-center mr-3 attendance-legend__item">
                  <div class="circle-note holiday attendance-legend__dot"></div>
                  <p class="mb-0">Nghỉ lễ</p>
                </div>
                <div md="2" class="d-flex at-center mr-3 attendance-legend__item">
                  <div class="circle-note no-need-checkin attendance-legend__dot"></div>
                  <p class="mb-0">Không cần chấm công</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-body mt-2 mb-2">
          <div class="main-body-table">
            <div class="calendar__block attendance-calendar-wrapper">
              <el-calendar
                v-if="!loading"
                :first-day-of-week="1"
                v-model="dateCalender"
              >
                <template slot="dateCell" slot-scope="{ date, data }">
                  <div class="calendar-day">
                    {{ data.day.split("-").slice(2).join("-") }}
                  </div>
                  <div class="block-date__work">
                    <div class="check" v-for="item in fn_getDayWork(calendarData,data.day)" :key="item.id">
                      <div
                        :class="fn_getWorksheetDisplayClass(item, fn_formatterDate(date))"
                        @click="fn_showDetail(item)"
                      ></div>
                    </div>
                  </div>

                </template>
              </el-calendar>
            </div>
            <b-row class="mt-3">
              <b-col md="9">
                <b-row>
                  <b-col md="3" lg="4">
                    <p>
                      Công hiện tại:
                      <span class="bold" style="color: #F79D61">
                        {{ Math.round(mData.totalWorkNow * 100) / 100 }}
                      </span>
                    </p>
                  </b-col>
                  <b-col md="3" lg="4">
                    <p>
                      Công chuẩn hiện tại:
                      <span class="bold" style="color: #30DA88">
                        {{ Math.round(mData.totalTheStandardNow * 100) / 100 }}
                      </span>
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="3" class="text-right">
                <b-link
                  style="text-decoration: underline"
                  class="bold"
                  href="javascript:"
                  @click="fn_goToHistory"
                  v-if="mData.dataDefault.listFeature.includes('FT902')"
                >
                  Xem lịch sử
                </b-link>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <!-- Dialog xem chi tiết ngày công -->
    <el-dialog
      :visible.sync="visibleDialogDetail"
      width="440px"
      top="180px"
      :before-close="closeDialogDetail"
      class="detail_work"
    >
      <div slot="title">
        <div class="d-flex jc-space-between work_information">
          <div class="bold name">
            <p>{{ mData.dataDetailWork.employee_name }}</p>
          </div>
          <div class="bold date">
            <p>Ngày {{ mData.dataDetailWork.date }}</p>
          </div>
        </div>
      </div>
      <div>
        <b-row>
          <b-col md="12" class="mb-1">
            <b-row>
              <b-col cols="6">
                <span>Ca làm: </span>
              </b-col>
              <b-col cols="6">
                <span class="bold">{{ mData.dataDetailWork.shift_code }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col cols="6">
                <span>Thời gian check in: </span>
              </b-col>
              <b-col cols="6">
                <span
                  class="bold"
                  v-if="!mData.dataDetailWork.haveTimeKeepingOnline && mData.dataDetailWork.is_need_checkin"
                >
                  {{
                    mData.dataDetailWork.time_check_in +
                    (mData.dataDetailWork.time_check_in &&
                    mData.dataDetailWork.time_check_out
                      ? "-"
                      : "") +
                    mData.dataDetailWork.time_check_out
                  }}
                </span>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút đi sớm: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_go_early }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút đi muộn: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_go_late }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút về sớm: </span></b-col>
              <b-col md="6"><span class="bold">{{mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_go_home_early }}</span></b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-row>
              <b-col md="6"><span>Số phút về muộn: </span></b-col>
              <b-col md="6"><span class="bold">{{ mData.dataDetailWork.haveTimeKeepingOnline || !mData.dataDetailWork.is_need_checkin ? 0 : mData.dataDetailWork.minute_overtime }}</span></b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-row>
              <b-col cols="6">
                <span>Công ghi nhận: </span>
              </b-col>
              <b-col cols="6" class="d-flex align-items-center">
                <template v-if="!editingWorkValue">
                  <span class="bold">
                    {{
                      mData.dataDetailWork.work_value
                        ? Math.round(mData.dataDetailWork.work_value * 100) / 100
                        : ""
                    }}
                  </span>
                  <i
                    v-if="mData.dataDefault.listFeature.includes('FT1103')"
                    class="el-icon-edit ml-1"
                    style="cursor:pointer;color:var(--orange)"
                    @click="fn_startEditWorkValue"
                  ></i>
                </template>
                <template v-else>
                  <el-input-number
                    v-model="tempWorkValue"
                    :min="0"
                    :precision="2"
                    size="mini"
                    style="width:110px"
                  ></el-input-number>
                </template>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="12">
            <b-row>
              <b-col cols="6">
                <span>Số lần vào ra: </span>
              </b-col>
              <b-col cols="6">
                <span class="bold">{{ mData.dataDetailWork.number_of_go_out }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="mb-1 d-flex">
            <b-row>
              <b-col md="12">
                <span class="request mb-1">Yêu cầu phép:</span>
                <ul v-if="loadEmployeeRequest">
                  <li
                    v-for="(item, index) in mData.dataDetailWork.requests"
                    :key="index"
                    class="list-request"
                  >
                    <b-link ref="javascript:" @click="goToRequestDetail(item.id)">
                      {{ item.title ? item.title : '' }}
                    </b-link>
                    ({{
                      item.status == "WAITING_FOR_APPROVAL"
                        ? "Chờ duyệt"
                        : item.status == "REJECTED"
                        ? "Từ chối"
                        : item.status == "APPROVED"
                        ? "Đã duyệt"
                        : ""
                    }})
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="12" class="text-right">
            <span
              class="see_more"
              @click="
                fn_seeMore(
                  mData.dataDetailWork.employee_id,
                  mData.dataDetailWork.shift_id,
                  mData.dataDetailWork.date,
                  mData.dataDetailWork.requests
                )
              "
              v-if="showMoreRequest"
            >
              Xem thêm
            </span>
          </b-col>
          <b-col
            md="12"
            class="text-right mt-2 pl-0 pr-0"
            v-if="mData.dataDefault.listFeature.includes('FT1004')"
          >
            <b-row>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() >=
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                "
                md="6"
                class="text-left pl-0 pr-0"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('day_off')"
                >
                  Tạo yêu cầu xin nghỉ
                </b-link>
              </b-col>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() >=
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                "
                md="6"
                class="text-left pl-0 pr-0"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('go_late')"
                >
                  Tạo yêu cầu đi muộn
                </b-link>
              </b-col>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() >=
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                "
                md="6"
                class="text-left pl-0 pr-0"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('go_home_early')"
                >
                  Tạo yêu cầu về sớm
                </b-link>
              </b-col>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() <
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                  "
                md="6"
                class="text-left pl-0 pr-0"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('work_addition',mData.dataDetailWork.date)"
                >
                  Tạo yêu cầu giải trình công
                </b-link>
              </b-col>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() >=
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 0, 0, 0).getTime()
                "
                md="6"
                class="text-left pl-0 pr-0"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('go_out')"
                >
                  Tạo yêu cầu ra ngoài
                </b-link>
              </b-col>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() >=
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 3 , 0, 0, 0).getTime()
                "
                md="6"
                class="text-left pl-0 pr-0"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('business')"
                >
                  Tạo yêu cầu công tác
                </b-link>
              </b-col>
              <b-col
                v-if="
                  new Date(mData.dataDetailWork.date1).getTime() ==
                  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() , 7, 0, 0).getTime()
                "
                md="6"
                class="text-left pl-0 pr-0"
              >
                <b-link
                  class="bold visible-underline"
                  href="javascript:"
                  @click="goToRequest('online')"
                >
                  Tạo yêu cầu chấm công online
                </b-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div v-if="editingWorkValue" slot="footer" class="text-center">
        <el-button round @click="editingWorkValue = false">Hủy</el-button>
        <el-button type="primary" round class="btn-default" @click="fn_saveWorkValue">Lưu</el-button>
      </div>
    </el-dialog>
    <Loading v-if="loading"/>
  </div>
</template>

<script>
import _ from "lodash";
import MethodService from "../../../../service/MethodService";
import SalaryPeriodApi from "../../../../moduleApi/SalaryPeriodApi";
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi";
import EmployeeWorkSheetModel from "./EmployeeWorkSheetModel";
import WorkApi from "../../../../moduleApi/WorkApi";
import EmployeeApi from "../../../../moduleApi/EmployeeApi";
import ShiftApi from "../../../../moduleApi/ShiftApi";
import DayOffApi from "../../../../moduleApi/DayOffApi";
import EmployeeShiftApi from "../../../../moduleApi/EmployeeShiftApi";
import Loading from "@/component/Loading"
import { Filter } from 'mushroomjs'

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      loadEmployeeRequest: true,
      showMoreRequest: true,
      calendarData: [], //Calculate cash back data by day
      dateCalender: new Date(),
      visibleDialogDetail: false,
      editingWorkValue: false,
      tempWorkValue: null,
      showCalendar: false,
      mData: {
        company: {},
        workSealedStatus: true,
        data: [],
        month: 0,
        year: 0,
        firstDayInMonth: "",
        lastDayInMonth: "",
        totalWorkNow: 0,
        totalTheStandardNow: 0,
        totalDayInMonth: 0,
        moduleName: "EmployeeWorksheet", //requied
        tableRules: MethodService.copyObject(EmployeeWorkSheetModel.tableRules),
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listSalaryPeriod: [],
          listEmployeeRequest: [],
          listWork: [],
          listEmployee: [],
          listShift: [],
          listEmployeeShift: [],
          listDayOff: [],
          listEmployeeRequestDetail: [],
        },
        dataDetailWork: {},
        currentUser: MethodService.getCurrentUser(),
      },
    };
  },

  methods: {
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    fn_getWorksheetDisplayClass(item, date) {
      if (!item || !item.work_value) return "circle-visible";

      const work = item.data || item;
      const isDayOff = this.mData.dataDefault.listDayOff.includes(date);
      const hasCheckin =
        work.checkin_time && typeof work.checkin_time.hour === "number";
      if (isDayOff && hasCheckin) {
        return "circle-note-work-table go-to-work-on-holiday mb-1";
      }
      if (isDayOff) {
        return "circle-note-work-table holiday mb-1";
      }

      const expectedValue = this.fn_getWorkExpectedValue(work);
      const workValue = Math.round((item.work_value || 0) * 100) / 100;
      if (workValue >= expectedValue) {
        return "circle-note-work-table full-work mb-1";
      }
      if (workValue > 0 && workValue < expectedValue) {
        return "circle-note-work-table work-have-problem mb-1";
      }
      if (item.is_need_checkin === false) {
        return "circle-note-work-table no-need-checkin mb-1";
      }

      return "circle-visible";
    },
    fn_getWorkExpectedValue(work) {
      if (!work || !work.number_of_day) return 1;
      return Math.round(work.number_of_day * 100) / 100;
    },
    fn_getWorkMinuteOfDay(value) {
      if (!value || value.hour == undefined || value.minute == undefined) {
        return null;
      }
      return value.hour * 60 + value.minute;
    },
    fn_getWorkScore(work) {
      if (!work) return Number.NEGATIVE_INFINITY;
      const expectedValue = this.fn_getWorkExpectedValue(work);
      const workValue = Math.round((work.work_value || 0) * 100) / 100;
      const fullWorkBonus = workValue >= expectedValue ? 100000 : 0;
      const latePenalty = Math.round((work.minute_go_late || 0) * 10);
      const earlyPenalty = Math.round((work.minute_go_home_early || 0) * 10);
      const checkinMinute = this.fn_getWorkMinuteOfDay(work.checkin_time);
      const checkoutMinute = this.fn_getWorkMinuteOfDay(work.checkout_time);
      const hasCheckinBonus = checkinMinute != null ? 1000 : 0;
      const hasCheckoutBonus = checkoutMinute != null ? 1000 : 0;
      const updatedAt = work.updated_at ? new Date(work.updated_at).getTime() : 0;
      const createdAt = work.created_at ? new Date(work.created_at).getTime() : 0;

      return (
        fullWorkBonus +
        Math.round(workValue * 1000) +
        hasCheckinBonus +
        hasCheckoutBonus -
        latePenalty -
        earlyPenalty +
        updatedAt / 1e10 +
        createdAt / 1e10
      );
    },
    fn_normalizeWorks(works) {
      if (!works || !works.length) return [];
      const grouped = _.groupBy(works, (item) =>
        [item.employee_id || "", item.shift_id || "", item.date || ""].join("|")
      );
      return Object.values(grouped).map((group) => {
        return _.orderBy(
          group,
          [
            (item) => this.fn_getWorkScore(item),
            (item) => (item.updated_at ? new Date(item.updated_at).getTime() : 0),
            (item) => (item.created_at ? new Date(item.created_at).getTime() : 0),
          ],
          ["desc", "desc", "desc"]
        )[0];
      });
    },
    async fn_initTable() {
      this.loading = true
      if (window.mushroom && window.mushroom.work) {
        window.mushroom.work.invalidCache();
      }
      if (window.mushroom && window.mushroom.employee_shift) {
        window.mushroom.employee_shift.invalidCache();
      }
      if (window.mushroom && window.mushroom.employee_request) {
        window.mushroom.employee_request.invalidCache();
      }
      const salaryPeriod = this.mData.dataDefault.listSalaryPeriod.find(item => item.id == this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id)
      this.mData.dataDefault.listWork = [];
      this.mData.workSealedStatus = false;
      let dataFilterWork = {
        limit: 1000,
        filters:
          "salary_period_id=" +
          this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id +
          "&employee_id=" +
          this.mData.currentUser.id,
      };
      let dataFilterEmployeeRequest = {
        sd: this.mData.firstDayInMonth,
        ed: this.mData.lastDayInMonth,
        cid: this.mData.company.id,
        eid: "",
      };
      const workApiReq = WorkApi.list(dataFilterWork, true);
      let filter = Filter.and(
        Filter.eq('employee_id', '$$user_id'),
        Filter.lte('start_time', this.mData.lastDayInMonth),
        Filter.or(
          Filter.isNull('end_time'),
          Filter.gte('end_time', this.mData.firstDayInMonth),
        )
      ).build()
      const employeeShiftApiReq = EmployeeShiftApi.list({
        limit: 9999999,
        filters: filter,
      }, true);
      const employeeRequestDetailApiReq =
        EmployeeRequestApi.getListEmployeeRequestDetail(
          dataFilterEmployeeRequest, true
        );

      const workApiRes = await workApiReq;
      const employeeShiftApiRes = await employeeShiftApiReq;
      const employeeRequestDetailApiRes = await employeeRequestDetailApiReq;

      this.mData.dataDefault.listEmployeeRequestDetail =
        employeeRequestDetailApiRes.result;

      if (workApiRes.result) {
        workApiRes.result = this.fn_normalizeWorks(workApiRes.result);
        this.mData.dataDefault.listWork = workApiRes.result;
      } else {
        this.mData.dataDefault.listWork = [];
      }
      if (employeeShiftApiRes.result) {
        this.mData.dataDefault.listEmployeeShift = employeeShiftApiRes.result
      } else {
        this.mData.dataDefault.listEmployeeShift = []
      }
      this.calendarData = [];
      for (let i = 1; i <= this.mData.totalDayInMonth; i++) {
        let obj = {
          date: i,
          work: undefined,
          employee_id: this.mData.currentUser.id,
        };
        let b = this.mData.dataDefault.listWork.find((x) => x.date == i);
        if (!b) {
          this.mData.dataDefault.listWork.push(obj);
        }
      }
      let check = this.mData.dataDefault.listWork.find(e => {
          return e.sealed === false;
        });
        if (!check) {
          this.mData.workSealedStatus = true;
        }
      this.mData.dataDefault.listWork.forEach((item) => {
        let data = {
          id: Math.random().toString(36).substring(2),
          sealed: item.sealed,
          date: `${this.mData.year}-${this.mData.month}-${(item.date < 10 ? "0" + item.date : item.date)}`,
          work_value: item.work_value,
          data: item,
        }
        let Shift = this.mData.dataDefault.listEmployeeShift.filter((e) => e.employee_id == item.employee_id && e.shift_id == item.shift_id)
        Shift.forEach(shift => {
          if (new Date(shift.end_time) <= new Date().getTime()) {
            if (item.date < new Date(shift.end_time).getDate()) {
              data.is_need_checkin = shift.is_need_checkin
            }
          } else if (new Date(shift.start_time).getTime() > new Date(salaryPeriod.from_date).getTime()) {
            if (item.date >= new Date(shift.start_time).getDate()) {
              data.is_need_checkin = shift.is_need_checkin
            }
          } else {
            data.is_need_checkin = shift.is_need_checkin
          }
        })
        this.calendarData.push(data);
      })
      this.mData.totalWorkNow = 0;
      this.calendarData.forEach((item) => {
        this.mData.totalWorkNow += item.work_value ? item.work_value : 0;
      })
      this.mData.totalTheStandardNow = 0
      let promises = []
      this.mData.dataDefault.listEmployeeShift.forEach(item => {
        promises.push(
          ShiftApi.CalcStandardWork({
            shiftId: item.shift_id,
            formDate: new Date(item.start_time).getTime() > new Date(MethodService.getFirstDayOfMonth(new Date(this.mData.firstDayInMonth))).getTime()
                        ? item.start_time
                        : MethodService.getFirstDayOfMonth(new Date(this.mData.firstDayInMonth)),
            toDate: !item.end_time || new Date(item.end_time).getTime() > new Date(MethodService.getLastDayOfMonth(new Date(this.mData.firstDayInMonth))).getTime()
                    ? MethodService.getLastDayOfMonth(new Date(this.mData.firstDayInMonth))
                    : item.end_time
          })
        )
      })
      Promise.all(promises).then(res => {
        res.forEach(e => this.mData.totalTheStandardNow += e.result.standardWork)
      })
      setTimeout(() => {
        document.querySelectorAll(".weekend").forEach((e) => {
          e.parentElement.classList.add("weekend_day");
        });
        document.querySelectorAll(".dayOff").forEach((e) => {
          e.parentElement.classList.add("day_off");
        });
      }, 1);
      this.loading = false
    },
    fn_getDayWork(arrData,date){
      let arrFilter = [];
      if (arrData && arrData.length > 0) {
        arrFilter = arrData.filter(e => {
          return e.date == date
        })
      }
      return arrFilter
    },
    async fn_initDataDefault() {
      this.mData.company = MethodService.getCompanyInfo();
      const salaryPeriodApiReq = SalaryPeriodApi.list({ limit: 10000 }, true);
      const employeeRequestApiReq = EmployeeRequestApi.list({ limit: 100000 }, true);
      const employeeApiReq = EmployeeApi.list({ limit: 100000 }, true);
      const shiftApiReq = ShiftApi.list({ limit: 10000 }, true);
      const dayOffApiReq = DayOffApi.list({ limit: 100000 }, true);

      const salaryPeriodApiRes = await salaryPeriodApiReq;
      const employeeRequestApiRes = await employeeRequestApiReq;
      const employeeApiRes = await employeeApiReq;
      const shiftApiRes = await shiftApiReq;
      const dayOffApiRes = await dayOffApiReq;

      this.mData.dataDefault.listSalaryPeriod = salaryPeriodApiRes.result;
      this.mData.dataDefault.listEmployeeRequest = employeeRequestApiRes.result;
      this.mData.dataDefault.listEmployee = employeeApiRes.result;
      this.mData.dataDefault.listShift = shiftApiRes.result;
      dayOffApiRes.result.forEach((item) => {
        this.mData.dataDefault.listDayOff.push(
          this.fn_formatterDate(item.off_date)
        );
      });

      this.mData.dataDefault.listSalaryPeriod.sort(function (a, b) {
        return (
          new Date(b.from_date).getTime() - new Date(a.from_date).getTime()
        );
      });
      let arrCunrentSalaryPeriod =
        this.mData.dataDefault.listSalaryPeriod.filter((item) => {
          return (
            new Date(item.from_date).getTime() <= new Date().getTime() &&
            new Date().getTime() < new Date(item.before_to_date).getTime()
          );
        });
      // console.log("arrCunrentSalaryPeriod",arrCunrentSalaryPeriod);
      if (arrCunrentSalaryPeriod.length > 0) {
        this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id = arrCunrentSalaryPeriod[0].id;
        this.mData.firstDayInMonth = new Date(MethodService.getFirstDayOfMonth(new Date(arrCunrentSalaryPeriod[0].from_date))).toISOString()
        this.mData.lastDayInMonth = new Date(MethodService.getLastDayOfMonth(new Date(arrCunrentSalaryPeriod[0].from_date))).toISOString()

        let datearray = this.fn_formatterDate(
          arrCunrentSalaryPeriod[0].from_date
        ).split("/");
        this.mData.month = datearray[1];
        this.mData.year = datearray[2];
        this.mData.totalDayInMonth = this.daysInMonth(
          this.mData.month,
          this.mData.year
        );
      }
    },
    async fn_changeSalaryPeriod() {
      if (!this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id) {
        this.showCalendar = true
        return
      }
      this.$router
        .replace({
          name: "Admin-Timekeeping-Employee-EmployeeWorksheet",
          query: {
            salaryPeriodId:
              this.mData.tableRules.dataSearchSalaryPeriod.value
                .salary_period_id,
          },
        })
        .catch((err) => {});
      const salaryPeriodApiReq = await SalaryPeriodApi.findById(
        this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id
      );
      this.mData.firstDayInMonth = new Date(MethodService.getFirstDayOfMonth(new Date(salaryPeriodApiReq.result.from_date))).toISOString();
      this.mData.lastDayInMonth = new Date(MethodService.getLastDayOfMonth(new Date(salaryPeriodApiReq.result.from_date))).toISOString()
      this.dateCalender = new Date(this.mData.firstDayInMonth);
      let datearray = this.fn_formatterDate(
        salaryPeriodApiReq.result.from_date
      ).split("/");
      this.mData.month = datearray[1];
      this.mData.year = datearray[2];
      this.mData.totalDayInMonth = this.daysInMonth(
        this.mData.month,
        this.mData.year
      );
      this.fn_initTable();
    },
    fn_formatterDate(cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },
    findEmployeeName(Eid) {
      let employee = this.mData.dataDefault.listEmployee.find((item) => {
        return item.id == Eid;
      });
      return employee &&
        employee.administrative_info &&
        employee.administrative_info.name &&
        employee.administrative_info.name.full_name
        ? employee.administrative_info.name.full_name
        : "";
    },
    findShiftCode(Sid) {
      let shift = this.mData.dataDefault.listShift.find((item) => {
        return item.id == Sid;
      });
      return shift && shift.code ? shift.code : "";
    },
    checkSealed(Sid,date){
      let isSealed = false;

      return isSealed
    },
    fn_showDetail(scope) {
      let arrRequestIds =
        scope.data && scope.data.employee_requests
          ? scope.data.employee_requests
          : [];
      this.mData.dataDetailWork = {
        id: scope.data.id || "",
        is_need_checkin: scope.is_need_checkin,
        employee_id: scope.data.employee_id,
        employee_no: scope.data.employee_no,
        employee_name: this.findEmployeeName(scope.data.employee_id),
        date:
          (scope.data.date < 10 ? "0" + scope.data.date : scope.data.date) +
          "/" +
          this.mData.month +
          "/" +
          this.mData.year,
        shift_code: this.findShiftCode(scope.data.shift_id),
        shift_id: scope.data.shift_id,
        time_check_in:
          (scope.data.checkin_time && scope.data.checkin_time.hour != undefined
            ? scope.data.checkin_time.hour < 10
              ? "0" + scope.data.checkin_time.hour
              : scope.data.checkin_time.hour
            : "") +
          (scope.data.checkin_time ? ":" : "") +
          (scope.data.checkin_time &&
          scope.data.checkin_time.minute != undefined
            ? scope.data.checkin_time.minute < 10
              ? "0" + scope.data.checkin_time.minute
              : scope.data.checkin_time.minute
            : ""),
        time_check_out:
          (scope.data.checkout_time &&
          scope.data.checkout_time.hour != undefined
            ? scope.data.checkout_time.hour < 10
              ? "0" + scope.data.checkout_time.hour
              : scope.data.checkout_time.hour
            : "") +
          (scope.data.checkout_time ? ":" : "") +
          (scope.data.checkout_time &&
          scope.data.checkout_time.minute != undefined
            ? scope.data.checkout_time.minute < 10
              ? "0" + scope.data.checkout_time.minute
              : scope.data.checkout_time.minute
            : ""),
        minute_go_early:
          scope.data && scope.data.minute_go_early
            ? Math.round(scope.data.minute_go_early * 100) / 100
            : "0",
        minute_go_late: scope.data.minute_go_late
          ? Math.round(scope.data.minute_go_late * 100) / 100
          : "0",
        minute_go_home_early: scope.data.minute_go_home_early
          ? Math.round(scope.data.minute_go_home_early * 100) / 100
          : "0",
        minute_overtime: scope.data.minute_overtime
          ? Math.round(scope.data.minute_overtime * 100) / 100
          : "0",
        work_value: Math.round(scope.data.work_value * 100) / 100,
        number_of_go_out:
          scope.data && scope.data.number_of_go_out
            ? scope.data.number_of_go_out
            : "0",
        isSealed: scope.sealed,
        requests: [],
        date1: scope.date,
      };
      arrRequestIds.forEach((item, index) => {
        let emRequest = this.mData.dataDefault.listEmployeeRequest.find(
          (e) => e.id === item.request_id
        );
        if (emRequest) {
          let obj = {
            id: emRequest.id,
            title: emRequest.title ? emRequest.title : emRequest.content,
            status: emRequest.status,
            type: emRequest.type,
          };

          this.mData.dataDetailWork.requests.push(obj);
        }
      });
      let checkHaveTimeKeepingOnline = this.mData.dataDetailWork.requests.find(e =>{
        return e.type == "TIME_KEEPING_ONLINE" && e.status == "APPROVED"
      })
      if (checkHaveTimeKeepingOnline != undefined) {
        this.mData.dataDetailWork.haveTimeKeepingOnline = true;
      } else {
        this.mData.dataDetailWork.haveTimeKeepingOnline = false;
      }
      this.visibleDialogDetail = true;
    },
    goToRequest(type,date) {
      if (type == "day_off") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-DayOffRequests",
            query: {
              employee_id: this.mData.currentUser.id,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "go_late") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoLateRequests",
            query: {
              employee_id: this.mData.currentUser.id,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "go_home_early") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoHomeEarlyRequests",
            query: {
              employee_id: this.mData.currentUser.id,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "work_addition") {
        let dateFormat = MethodService.formatterMMDDYYYY(date);
        let day = new Date(dateFormat).getDate();
        let month = new Date(dateFormat).getMonth();
        let year = new Date(dateFormat).getFullYear();
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-WorkAdditionRequests",
            query:{
              day: day,
              month: month + 1,
              year: year,
              employee_id: this.mData.currentUser.id,
              shift_id: this.mData.dataDetailWork.shift_id,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "go_out") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoOutRequests",
            query: {
              employee_id: this.mData.currentUser.id,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "business") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-GoOnBussinessRequests",
            query: {
              employee_id: this.mData.currentUser.id,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      } else if (type == "online") {
        let routeData = this.$router
          .resolve({
            name: "Admin-ManageRequests-ListRequests-TimeKeepingOnlineRequests",
            query: {
              employee_id: this.mData.currentUser.id,
              from: "WorkSheet"
            }
          });
        window.open(routeData.href, '_blank');
      }
    },
    goToRequestDetail(id) {
      let routeData = this.$router
        .resolve({
          name: "Admin-ManageRequests-CheckRequest",
          params: { id: id },
          query: {
            from: "WorkSheet"
          }
        });
      window.open(routeData.href, '_blank');
    },
    fn_goToHistory() {
      this.$router.push({
        name: "Admin-Timekeeping-Employee-EntryAndExitHistory",
        query: {
          salaryPeriodId: this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id,
        },
      });
    },
    closeDialogDetail() {
      this.visibleDialogDetail = false;
      this.showMoreRequest = true;
      this.editingWorkValue = false;
    },
    fn_startEditWorkValue() {
      this.tempWorkValue = parseFloat(this.mData.dataDetailWork.work_value) || 0;
      this.editingWorkValue = true;
    },
    async fn_saveWorkValue() {
      if (!this.mData.dataDetailWork.id) {
        window.toastr.error("Không thể cập nhật công vì chưa có bản ghi công cho ngày này");
        return;
      }
      try {
        await WorkApi.update({
          id: this.mData.dataDetailWork.id,
          work_value: parseFloat(this.tempWorkValue)
        });
        this.mData.dataDetailWork.work_value = this.tempWorkValue;
        this.editingWorkValue = false;
        this.fn_initTable();
        window.toastr.success("Cập nhật công ghi nhận thành công");
      } catch (error) {
        window.toastr.error("Cập nhật công ghi nhận thất bại");
      }
    },
    fn_seeMore(employee_id, shift_id, date, employeeRequests) {
      let currentDate = new Date(MethodService.formatterMMDDYYYY(date));
      let datePlus12H = currentDate.setHours(currentDate.getHours() + 12);
      let day = new Date(MethodService.formatterMMDDYYYY(date)).getDate();
      let month = new Date(MethodService.formatterMMDDYYYY(date)).getMonth();
      let year = new Date(MethodService.formatterMMDDYYYY(date)).getFullYear();

      let moreRequest = this.mData.dataDefault.listEmployeeRequestDetail.filter(
        (e) => {
          let dayOff = null;
          if (e.day_off) {
            dayOff = e.day_off.find((x) => {
              return (
                x.shift_id == shift_id &&
                new Date(x.day).getDate() == day &&
                new Date(x.day).getMonth() == month &&
                new Date(x.day).getFullYear() == year
              );
            });
          }
          return (
            e.employee_id == employee_id &&
            ((e.shift_go_late == shift_id &&
              new Date(e.extra_minute_go_late).getDate() == day &&
              new Date(e.extra_minute_go_late).getMonth() == month &&
              new Date(e.extra_minute_go_late).getFullYear() == year) ||
              (e.shift_go_home == shift_id &&
                new Date(e.extra_minute_go_home).getDate() == day &&
                new Date(e.extra_minute_go_home).getMonth() == month &&
                new Date(e.extra_minute_go_home).getFullYear() == year) ||
              (e.shift_go_out == shift_id &&
                new Date(e.start_date_go_out).getDate() == day &&
                new Date(e.start_date_go_out).getMonth() == month &&
                new Date(e.start_date_go_out).getFullYear() == year) ||
              (e.day_off && dayOff) ||
              (e.shift_work_online == shift_id &&
                new Date(e.online_date).getDate() == day &&
                new Date(e.online_date).getMonth() == month &&
                new Date(e.online_date).getFullYear() == year) ||
              (e.shift_work_add == shift_id &&
                new Date(e.end_date_work_add).getDate() == day &&
                new Date(e.end_date_work_add).getMonth() == month &&
                new Date(e.end_date_work_add).getFullYear() == year) ||
              (new Date(e.start_date_bussiness).getTime() <= datePlus12H &&
                new Date(e.end_date_bussiness).getTime() >= datePlus12H))
          );
        }
      );
      if (moreRequest.length > 0) {
        this.loadEmployeeRequest = false;
        this.mData.dataDetailWork.requests = [];
        moreRequest.forEach((e) => {
          let obj = {
            id: e.id,
            title: e.title ? e.title : e.content,
            status: e.status,
          };
          this.mData.dataDetailWork.requests.push(obj);
        });
        this.loadEmployeeRequest = true;
      }
      this.showMoreRequest = false;
    },
    async fn_hashUrl() {
      if (this.$route.query.salaryPeriodId) {
        this.mData.tableRules.dataSearchSalaryPeriod.value.salary_period_id = this.$route.query.salaryPeriodId
      }
      this.fn_changeSalaryPeriod()
    },
  },

  async created() {
    await this.fn_initDataDefault();
    this.fn_hashUrl();
  },
};
</script>

<style scoped>
.calendar__block {
  min-height: calc(100vh - 290px);
  background: #fff;
  border-radius: 10px;
}
::v-deep .el-select{
  width: 230px;
}
::v-deep .el-calendar-table .el-calendar-day:hover{
  cursor: context-menu;
}
.check{
  display: inline-block;
  margin-right: 5px;
  min-width: 40px;
}
.check:hover{
  cursor: pointer;
}
.block-date__work{
  text-align: right;
}
::v-deep .weekend_day {
  background-color: rgb(243, 242, 242);
}
::v-deep .day_off {
  background-color: #00D1FF !important;
  border-color: #d9eced !important;
}
::v-deep .off_day {
  background-color: #00D1FF !important;
  border-color: #d9eced !important;
}
::v-deep .text-left .disabled {
  color: gray;
}
::v-deep .text-left .disabled:hover {
  cursor: no-drop;
}
::v-deep .el-calendar {
  border-radius: 20px;
}
::v-deep .el-calendar__header {
  display: none;
}
::v-deep .el-calendar__body .el-calendar-table thead {
  text-align: center;
}
::v-deep .el-calendar__body .el-calendar-table thead th {
  font-weight: bold;
  font-size: 16px;
}
::v-deep .is-today {
  background-color: #FFD8BD;
  color: #666666 !important;
  font-weight: bold;
}
::v-deep .detail_work .el-dialog__header{
  padding: 8px 10px;
}
::v-deep .detail_work .el-dialog__header .title{
  display: flex;
  justify-content: space-between;
  margin-right: 25px;
}
::v-deep .detail_work .el-dialog__header .title p{
  color: var(--white);
}
.list-request {
  word-break: initial;
}
.el-dialog__body span{
  color: #000 !important;
}
.work_information{
  margin-right: 29px;
}
.name p{
  display: block;
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.name p,.date p{
  color: var(--white) !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}
.see_more {
  color: #1597e5;
  font-weight: bold;
  font-style: italic;
}
.see_more:hover {
  cursor: pointer;
}

.attendance-header__title {
  flex: 0 0 auto;
}

.attendance-header__title h4 {
  white-space: nowrap;
}

@media (max-width: 767px) {
  .employee-worksheet,
  .employee-worksheet .card,
  .employee-worksheet .main-card-body,
  .employee-worksheet .main-body,
  .employee-worksheet .main-body-table {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin: 0;
    box-sizing: border-box;
  }

  .employee-worksheet {
    overflow-x: hidden;
  }

  .employee-worksheet .card {
    border: 0;
    box-shadow: none;
    background: transparent;
  }

  .employee-worksheet .main-card-body {
    padding: 0;
  }

  .employee-worksheet__header,
  .attendance-header,
  .attendance-header__title-row,
  .attendance-legend-wrap,
  .attendance-calendar-wrapper {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin-left: 0;
    margin-right: 0;
    box-sizing: border-box;
  }

  .attendance-header {
    flex-direction: column;
    align-items: stretch !important;
    gap: 12px;
  }

  .attendance-header__title-row {
    flex-direction: column;
    align-items: stretch !important;
    gap: 12px;
  }

  .attendance-header__title {
    width: 100%;
  }

  .attendance-header__title h4 {
    margin: 0;
    font-size: 22px;
    line-height: 1.25;
  }

  .attendance-header__month {
    width: 100%;
    margin-left: 0 !important;
  }

  .attendance-header__month ::v-deep .el-select,
  .attendance-header__month ::v-deep .el-input,
  .attendance-header__month ::v-deep .el-input__inner {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .attendance-legend-wrap {
    justify-content: flex-start !important;
  }

  .attendance-legend {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 12px;
    width: 100%;
    margin: 4px 0 14px;
  }

  .attendance-legend__item {
    min-width: 0;
    margin-right: 0 !important;
    align-items: flex-start !important;
    gap: 8px;
  }

  .attendance-legend__dot {
    width: 14px;
    height: 14px;
    min-width: 14px;
    flex: 0 0 14px;
    margin-top: 4px;
  }

  .attendance-legend__item p {
    min-width: 0;
    line-height: 1.35;
    word-break: normal;
    overflow-wrap: break-word;
  }

  .attendance-calendar-wrapper {
    min-height: 0;
    padding: 0;
    border-radius: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .attendance-calendar-wrapper ::v-deep .el-calendar {
    width: 100%;
    min-width: 0;
    border-radius: 16px;
  }

  .attendance-calendar-wrapper ::v-deep .el-calendar__body {
    width: 100%;
    padding: 14px 10px 12px;
    box-sizing: border-box;
  }

  .attendance-calendar-wrapper ::v-deep .el-calendar-table {
    width: 100%;
    table-layout: fixed;
  }

  .attendance-calendar-wrapper ::v-deep .el-calendar-table th {
    padding: 8px 2px;
    text-align: center;
    font-size: 14px;
  }

  .attendance-calendar-wrapper ::v-deep .el-calendar-table td {
    min-width: 0;
  }

  .attendance-calendar-wrapper ::v-deep .el-calendar-day {
    min-height: 74px;
    height: 74px;
    padding: 8px 4px;
    text-align: center;
    box-sizing: border-box;
  }

  .calendar-day {
    font-size: 14px;
  }

  .block-date__work {
    text-align: center;
  }

  .check {
    min-width: 0;
    margin-right: 2px;
  }

  .circle-note-work-table {
    width: 10px;
    height: 10px;
  }
}

@media (min-width: 600px) and (max-width: 767px) {
  .attendance-legend {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
</style>
